import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = Record<string, unknown> & { withoutLockedUsers?: boolean };

export const schemaUserResolver_GetUsers = z.array(UsersTableDefinitionZod);

export type SchemaUserResolver_GetUsers = z.infer<typeof schemaUserResolver_GetUsers>;

export type UserResolver_GetUsers = Resolver<Arguments, SchemaUserResolver_GetUsers>;
